import common from "./common";
import errors from "./errors";
import transactions from "./transactions";
import applications from "./applications";
import accounts from "./accounts";
import users from "./users";
import countries from "./countries";
import dashboard from "./dashboard";
import company from "./company";
import customers from "./customers";
import currencies from "./currencies";
import customersCheckoutBranding from "./customersCheckoutBranding";

const index = {
  common,
  errors,
  transactions,
  applications,
  accounts,
  users,
  countries,
  company,
  dashboard,
  customers,
  currencies,
  customersCheckoutBranding,
};

export default index;
